import { Flex } from "antd";
import { type Dispatch, type SetStateAction, useMemo } from "react";
import { useIntl } from "react-intl";

import CustomSelect from "~components/CustomSelect";
import type { UserRoles } from "~enums/userRoles";
import { userRolesByPriority } from "../../constants/userRolesByPriority";
import { UserStatuses } from "../enums/userStatuses";

const userStatusOptions: UserStatuses[] = [UserStatuses.Active, UserStatuses.Pending];

type Props = {
  setRoles: Dispatch<SetStateAction<Set<UserRoles>>>;
  setStatus: Dispatch<SetStateAction<UserStatuses | undefined>>;
  disabled?: boolean;
};

const UsersFilters = ({ setRoles, setStatus, disabled = false }: Props) => {
  const { formatMessage } = useIntl();
  const roleFilterOptions = useMemo(
    () =>
      userRolesByPriority.map((userRole) => ({
        label: formatMessage({ id: `permissions.userRole.${userRole}` }),
        value: userRole,
      })),
    [formatMessage],
  );
  const statusFilterOptions = useMemo(
    () =>
      userStatusOptions.map((status) => ({
        label: formatMessage({ id: `permissions.user.status.${status}` }),
        value: status,
      })),
    [formatMessage],
  );

  return (
    <Flex gap={8}>
      <CustomSelect
        mode="multiple"
        onChange={(roles) => setRoles(new Set(roles as UserRoles[]))}
        options={roleFilterOptions}
        allowClear
        placeholder={formatMessage({ id: "permissions.user.role.type" })}
        disabled={disabled}
        maxTagCount="responsive"
        style={{ minWidth: 170 }}
      />
      <CustomSelect
        onChange={(status) => setStatus(status as UserStatuses)}
        options={statusFilterOptions}
        allowClear
        placeholder={formatMessage({ id: "status" })}
        disabled={disabled}
        style={{ minWidth: 100 }}
      />
    </Flex>
  );
};

export default UsersFilters;
